import { render, staticRenderFns } from "./icon-renderer-light.vue?vue&type=template&id=641b5b14&scoped=true"
import script from "./icon-renderer-light.vue?vue&type=script&lang=js"
export * from "./icon-renderer-light.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b5b14",
  null
  
)

export default component.exports